import z from 'zod';

import { ShoppingCartStateSchema } from './ShoppingCartState';
import { ShoppingCartState } from './ShoppingCartState';

export type ShoppingCartDto = {
	id: string;
	state: ShoppingCartState;
	isDefault: boolean;
	lastEditedDateUtc: string;
	creator: string | null;
	creatorId: string | null;
	nameTranslations: { [key: string]: string };
	descriptionTranslations: { [key: string]: string };
};

export const ShoppingCartDtoSchema: z.ZodType<ShoppingCartDto> = z.object({
	id: z.string(),
	state: z.lazy(() => ShoppingCartStateSchema),
	isDefault: z.boolean(),
	lastEditedDateUtc: z.string(),
	creator: z.string().nullable(),
	creatorId: z.string().nullable(),
	nameTranslations: z.record(z.string()),
	descriptionTranslations: z.record(z.string()),
});
